import { http } from '@/api/index';

export const upgradeExtensionVersion = () => {
  return http.post(`extensions`);
};

export const getExtensions = () => {
  return http.get(`extensions`);
};
